import { createAction } from 'typesafe-actions'

import { BudgetYear } from '../page/budget.types'

export const loadBudgetSettings = createAction('SETTINGS/loadBudget')<BudgetYear>()
